module.exports = __webpack_public_path__ + "img/system13-details.a0b20565.png";